import React, {useEffect} from 'react';
import {Controller} from "react-hook-form";
import {
		Box,
		Button,
		Card,
		CardContent,
		CardHeader,
		Divider,
		Grid,
		TextField,
} from '@material-ui/core';
import ParkingZoneRepository from "../../../repositories/ParkingZoneRepository";
import {useNavigate, useParams} from "react-router";
import FormLoading from "../../../components/FormLoading";
import {useCrudForm} from "../../../hooks/crud/Form";
import {useTranslation} from "react-i18next";
import WorkingTimeWeekly from "../../../components/WorkingTimeWeekly";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {weekdays} from "../../../data/data";

const Form = () => {
	const navigate = useNavigate();
	const {t} = useTranslation();
	const permitIdPattern = /^([0-9]+ *\,?)+$/ig;

	const {id} = useParams();
	const repository = new ParkingZoneRepository();

    const onBeforeLoad = (data) => {
        if (data.PermitSystemIds) {
            data.PermitSystemIds = data.PermitSystemIds.join(",");
        }

        return data;
    }

    const onBeforeSave = (data) => {

        if (data.PermitSystemIds) {
            data.PermitSystemIds = data.PermitSystemIds.match(/([0-9]+)/g);
        } else {
            data.PermitSystemIds = [];
        }
        return data;
    }

	const { form, onSubmit, isSubmitting, hasError, errorMessage } =
        useCrudForm(repository, { id: id, onSuccess: () =>  navigate("/app/parking-zones"), onBeforeLoad: onBeforeLoad, onBeforeSave: onBeforeSave });
    const { control, register, unregister, setValue } = form;

    const isNumberArray = (value) => {
        if (value.length == 0) {
            return true;
        }

        value = '' + value;

        return value.match(permitIdPattern) ? true : false;
    };

    const mapWeekdayMap = (input) => {

        return weekdays.map((weekday) => {
           if (input) {
               const weekdayValue = input.filter(x => x.Weekday == weekday.value);
               if (weekdayValue.length > 0) {
                   return { Weekday: weekday.value, From: weekdayValue[0].From, To: weekdayValue[0].To };
               } else {
                   return { Weekday: weekday.value, From: 0, To: 24 * 60 };
               }
           } else {
               return { Weekday: weekday.value, From: 0, To: 24 * 60 };
           }
        });
    }

    useEffect(() => {

        register("WorkingTimes");

        if (!id) {
            setValue("WorkingTimes", mapWeekdayMap(null));
        }
        return () => {
            unregister("WorkingTimes");
        }
    }, [])

	 return (
			<form onSubmit={onSubmit}
			>
                 <Grid item xs={12} lg={8}>
                     {isSubmitting && <FormLoading />}
                        <Grid container>
                            <Grid item lg={6} xs={12}>
                                <Box p={0.5}>
                                    <Card>
                                        <CardHeader title={t('Information')} />
                                        <Divider />
                                        <CardContent>

                                             <Box>
                                                <Controller
                                                     as={TextField} control={control}
                                                     error={hasError('Name')}
                                                     fullWidth
                                                     helperText={errorMessage('Name')}
                                                     label={t('Name')}
                                                     type={"text"}
                                                     name="Name"
                                                     defaultValue={""}
                                                     variant="outlined"
                                                     rules={{ required: true }}
                                                />
                                             </Box>
                                             <Box mt={3}>
                                                <Controller
                                                     as={TextField} control={control}
                                                     error={hasError('Code')}
                                                     fullWidth
                                                     helperText={errorMessage('Code')}
                                                     label={t('Code')}
                                                     type={"text"}
                                                     name="Code"
                                                     defaultValue={""}
                                                     variant="outlined"
                                                     rules={{ required: false }}
                                                />
                                             </Box>
                                             <Box mt={3}>
                                                <Controller
                                                     as={TextField} control={control}
                                                     error={hasError('FineAmount')}
                                                     fullWidth
                                                     helperText={errorMessage('FineAmount')}
                                                     label={t('Fine amount')}
                                                     type={"text"}
                                                     name="FineAmount"
                                                     defaultValue={""}
                                                     variant="outlined"
                                                     rules={{ valueAsNumber: true }}
                                                />
                                             </Box>

                                             <Box mt={3}>
                                                <Controller
                                                     as={TextField} control={control}
                                                     error={hasError('MaxDayAmount')}
                                                     fullWidth
                                                     helperText={errorMessage('MaxDayAmount')}
                                                     label={t('Max day amount')}
                                                     type={"text"}
                                                     name="MaxDayAmount"
                                                     defaultValue={""}
                                                     variant="outlined"
                                                     rules={{ valueAsNumber: true }}
                                                />
                                             </Box>

                                             <Box mt={3}>
                                                <Controller
                                                     as={TextField} control={control}
                                                     error={hasError('ToleranceTime')}
                                                     fullWidth
                                                     helperText={errorMessage('ToleranceTime')}
                                                     label={t('Tolerance time (mins)')}
                                                     type={"text"}
                                                     name="ToleranceTime"
                                                     defaultValue={""}
                                                     variant="outlined"
                                                     rules={{ valueAsNumber: true, min: 0, max: 9999 }}
                                                />
                                             </Box>

                                             <Box mt={3}>
                                                <Controller
                                                     as={TextField} control={control}
                                                     error={hasError('GraceTime')}
                                                     fullWidth
                                                     helperText={errorMessage('GraceTime')}
                                                     label={t('Grace time (mins)')}
                                                     type={"text"}
                                                     name="GraceTime"
                                                     defaultValue={""}
                                                     variant="outlined"
                                                     rules={{ valueAsNumber: true, min: 0, max: 9999 }}
                                                />
                                             </Box>

                                            <Box mt={3}>
                                                <Controller
                                                    as={TextField} control={control}
                                                    error={hasError('ForgiveFineForLongParking')}
                                                    fullWidth
                                                    helperText={errorMessage('ForgiveFineForLongParking')}
                                                    label={t('Forgive fine when parking is longer (hours)')}
                                                    type={"text"}
                                                    name="ForgiveFineForLongParking"
                                                    defaultValue={""}
                                                    variant="outlined"
                                                    rules={{ valueAsNumber: true, min: 0, max: 9999 }}
                                                />
                                            </Box>


                                            <Box mt={3}>
                                                <Controller
                                                        name="IsActive"
                                                        control={control}
                                                        defaultValue={false}
                                                        render={({ value, onChange, checked }) => (
                                                                    <FormControlLabel control={(
                                                                          <Switch
                                                                            checked={value}
                                                                            value={value}
                                                                            onChange={(event, value) => onChange(value)}
                                                                          />)} label={t('Active')} />
                                                                        )}
                                                      />
                                            </Box>
                                        </CardContent>
                                     </Card>
                                    <Card>
                                        <CardHeader title={t('Integration')} />
                                        <Divider />
                                        <CardContent>
                                             <Box>
                                                <Controller as={TextField} control={control}
                                                                 error={hasError('ParkomaticId')}
                                                                 fullWidth
                                                                 type={"text"}
                                                                 helperText={errorMessage('ParkomaticId')}
                                                                 label={t('Parkomatic Id')}
                                                                 name="ParkomaticId"
                                                                 defaultValue={""}
                                                                 variant="outlined"
                                                                 rules={{ valueAsNumber: true }}
                                                />
                                             </Box>
                                             <Box mt={3}>
                                                <Controller as={TextField} control={control}
                                                                 error={hasError('FineSystemId')}
                                                                 fullWidth
                                                                 type={"text"}
                                                                 helperText={errorMessage('FineSystemId')}
                                                                 label={t('ParkEnforcer Id')}
                                                                 name="FineSystemId"
                                                                 defaultValue={""}
                                                                 variant="outlined"/>
                                             </Box>
                                             <Box mt={3}>
                                                <Controller as={TextField} control={control}
                                                                 error={hasError('PermitSystemIds')}
                                                                 fullWidth
                                                                 type={"text"}
                                                                 helperText={errorMessage('PermitSystemIds')}
                                                                 label={t('Billing Id (use "," for multiple values)')}
                                                                 name="PermitSystemIds"
                                                                 defaultValue={""}
                                                                 rules={{ validate: isNumberArray }}
                                                                 variant="outlined"/>
                                             </Box>
                                        </CardContent>
                                     </Card>
                                </Box>
                            </Grid>
                            <Grid item lg={6} xs={12}>
                                <Box p={0.5}>
                                    <Card>
                                        <CardHeader title={t('Working time')} />
                                        <Divider />
                                        <CardContent>
                                            <Controller control={control} name="WorkingTimes" defaultValue={null} render={({value, onChange}) => {
                                                return (<WorkingTimeWeekly value={value} onChange={onChange}/>)
                                            }} />
                                        </CardContent>
                                     </Card>
                                </Box>
                            </Grid>
                        </Grid>
                     </Grid>
                     <Box mt={2}>
                         <Button
                            color="secondary"
                            variant="contained"
                            type="submit"
                            name="submit"
                            disabled={isSubmitting}
                        >
                            {t('Save')}
                        </Button>
                     </Box>
                </form>
	);
};

export default Form;